module.exports = __webpack_public_path__ + "media/images/icon_reg_small-3bdf5bc6403486057e2543a8a40dd8ea.png";